import { create } from "zustand";

const useDiscountFormStore = create((set) => ({
  isDirty: false,
  isSaving: false,
  discountData: null,
  error: null,

  // Actions
  setIsDirty: (value) => set({ isDirty: value }),
  setIsSaving: (value) => set({ isSaving: value }),
  setDiscountData: (data) => set({ discountData: data }),
  setError: (error) => set({ error }),
  resetStore: () =>
    set({
      isDirty: false,
      isSaving: false,
      discountData: null,
      error: null,
    }),
}));

export default useDiscountFormStore;
